import script from "./AppActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppActivity.vue?vue&type=script&lang=ts&setup=true"

import "./AppActivity.vue?vue&type=style&index=0&id=2d80f198&lang=scss"

const __exports__ = script;

export default __exports__